module.exports = __webpack_public_path__ + "img/obby_1.293d5fac.png";